const Condition = require('./Condition');
const BattleCalc = require('../BattleCalc');

const OffensiveStanceCondition = function (
  instigator,
  owner,
  battleState,
  potency
) {
  let extant = BattleCalc.getCondition(owner, 'offensive_stance');
  if (extant) {
    return extant;
  } else {
    extant = BattleCalc.getCondition(owner, 'defensive_stance');
    if (extant) {
      battleState.expireCondition(extant.uid);
    } else {
      const condition = new Condition(instigator, owner, battleState, potency);
      condition.handle = 'offensive_stance';
      condition.ConditionClass = OffensiveStanceCondition;
      return condition;
    }
  }
};

OffensiveStanceCondition.fromCopy = function(cState, owner, instigator, battleState) {
  return OffensiveStanceCondition(instigator, owner, battleState, cState.potency);
};

module.exports = OffensiveStanceCondition;
